import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@utils/permissionGuard'
import '@utils/request'
import '@utils/plugins'
import '@utils/directives'
import 'dayjs'

import './icons'

import 'normalize.css'

import ModalHeader from '@/components/ModalHeader'
Vue.component('ModalHeader', ModalHeader)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
